/**
 * 时间戳 -> 2022-7-27 14:51:13
 * @param {*} time 
 * @returns 
 */
export function formateDate(time) {
  if (!time) return ''
  let date = new Date(time)
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() + 1) +
    '-' +
    date.getDate() +
    ' ' +
    date.getHours() +
    ':' +
    date.getMinutes() +
    ':' +
    date.getSeconds()
  )
}

/**
 * 2022-02-14T00:00:00Z -> 2022-02-14 08:00:00
 * @param {*} date 
 * @returns 
 */
export function rTime(date) {
  var json_date = new Date(date).toJSON()
  return new Date(+new Date(json_date) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, ' ')
    .replace(/\.[\d]{3}Z/, '')
}
